<template>
  <div class="hidden" />
</template>

<script setup lang="ts">
import { getUrlParam, getTemplateData } from '@/utils'
import { useBundleStore } from '@/stores'
const bundle = useBundleStore()
const variant = getUrlParam('variant')

if (variant) {
  const mapping = getTemplateData('#json-variant-map')?.[variant]
  if (mapping) {
    bundle.setSelectedSize(mapping.size)
    bundle.plan = mapping.plan
  }
} else {
  bundle.readUrlParams()
}
</script>
